var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderStyles1'),_c('router-view'),_c('PageFooter'),_c('CookiesConsent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }